import BaseService from './BaseService'
import store from '../../store'

function getBaseService(baseUrlName) {
  const appConfig = store.getters.appConfig
  return new BaseService(appConfig[baseUrlName])
}

export default class HttpService {
  static getTargetUrl(baseUrl, params) {
    return BaseService.getTargetUrl(baseUrl, params)
  }

  //获取通用的基础服务
  static getCommonService(baseName) {
    return getBaseService(baseName)
  }

  static getUserService() {
    return getBaseService('userUrl')
  }

  static getApiService() {
    return getBaseService('apiUrl')
  }

  static getProService() {
    return getBaseService('proUrl')
  }

  static getPermissionService() {
    return getBaseService('permissionUrl')
  }

  static getBaseService() {
    return getBaseService('baseUrl')
  }

  static getOrderService() {
    return getBaseService('orderUrl')
  }

  static getServerApiService() {
    return getBaseService('serviceUrl')
  }

  static getPayApiService() {
    return getBaseService('payUrl')
  }

  static getSmsApiService() {
    return getBaseService('smsUrl')
  }

  static getPreSmsApiService() {
    return getBaseService('preSmsUrl')
  }

  static getInterPayApiService() {
    return getBaseService('interPayUrl')
  }

  static getConnService() {
    return getBaseService('connUrl')
  }

  static getResourceService() {
    return getBaseService('resourceUrl')
  }

  static getCouponService() {
    return getBaseService('conponUrl')
  }

  static getShortService() {
    return getBaseService('shortUrl')
  }

  static getCloudUserService() {
    return getBaseService('cloudUserUrl')
  }

  static getCloudProService() {
    return getBaseService('cloudProUrl')
  }

  static getCloudOrderService() {
    return getBaseService('cloudOrderUrl')
  }

  static getDirectPresaleService() {
    return getBaseService('directPresaleUrl')
  }

  static getDirectTicketsService() {
    return getBaseService('directTicketsUrl')
  }

  static getPactService() {
    return getBaseService('pactUrl')
  }

  static getIntegralApiService() {
    return getBaseService('pointsUrl')
  }

  /**
   * 新服务，员工认证
   * @returns {BaseService}
   */
  static getMemberAuthService() {
    return getBaseService('memberAuthUrl')
  }

  /**
   * 获取自我游服务
   * @returns {BaseService}
   */
  static getSourceService() {
    return getBaseService('sourceUrl')
  }

  static getServeService() {
    return getBaseService('serveUrl')
  }

  static getWebDataService() {
    return getBaseService('webDataUrl')
  }

  static getNewServeService() {
    return getBaseService('newServeUrl')
  }

  static getNewSmsService() {
    return getBaseService('newSmsUrl')
  }
}